import { render, staticRenderFns } from "./_loading.vue?vue&type=template&id=2507e8ac"
import script from "./_loading.vue?vue&type=script&lang=js"
export * from "./_loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports